import React from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash'; 
import { setCurrentPage } from '../Navigation/currentPage';
import { SCR_OVERVIEW } from '../enums';
import { getLabel } from '../Language/labels';

const ViewEntry = ({pageState, dispatch}) => {

  const {description, name, video_youtube_url} = pageState.entry;
  const imageUrl = get(pageState, 'entryImage.images.data[0].image.cdn', '');
  
  return (
    <>
      <h1 className="overview-title">{getLabel('viewEntryTitle')}</h1>
      <div className='view-entry-wrapper'>
        <img className='view-entry-image ' src={imageUrl} alt="competition category" />
        <div className='view-entry-details'>
          <h1>{name}</h1>
          <h2>{get(pageState, 'category.data.name', '')}</h2>
          <a href={video_youtube_url}>{getLabel('viewEntryVideoUrl')}</a>
          <p>{description}</p>
          <button onClick={() => dispatch(setCurrentPage(SCR_OVERVIEW))} type='button' className='form-submit m-0'>
            {getLabel('viewEntryBack')}
          </button>
        </div>
      </div>
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    pageState: state.pageState
  }
}

export default connect(mapStateToProps)(ViewEntry)